<template>
  <ul>
    <li
      v-for="(category, index) in categories"
      :key="index"
      @click="toggleSelect(index)"
      :class="{'-selected': category.selected}"
    >
      <svg>
        <use :xlink:href="`#icon-${category.icon}`"></use>
      </svg>
      {{ category.label }}
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  methods: {
    toggleSelect(index) {
      this.$store.commit('vehicles/filters/TOGGLE_CATEGORY_SELECT', index)
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../../../_src/sass/config/vars";
@import "../../../../../_src/sass/config/mixins";
@import "../../../../../_src/sass/config/responsive";

ul {
  display: flex;
  justify-content: space-between;
  margin-right: 20px;
  width: 100%;

  @include teq-breakpoint($medium) {
    margin: auto;
  }
}

li {
  align-items: center;
  background: white;
  border: solid 1px $c-alto;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100px;
  justify-content: center;
  max-width: 183px;
  transition: background-color 150ms ease-out, color 150ms ease-out;
  width: 100%;

  &:hover {
    background: $c-mercury;
  }

  &.-selected {
    background: $black;
    color: white;
  }
}

svg {
  margin: 0 0 10px;
  max-height: 30px;
  max-width: 58px;
  transition: fill 150ms ease-out;

  .-selected & {
    fill: white;
  }
}

</style>
